import '../default/site-scripts.js';

export default document.addEventListener('DOMContentLoaded', function () {

    // Modify default navbar to be always "mobile"
    document.querySelector('#site > header nav.navbar').classList.remove('navbar-expand-lg');
    document.querySelector('#site > header nav.navbar div.offcanvas').classList.remove('offcanvas-lg');
});